/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useState, useMemo, useEffect } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/TableList2.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
// import PaginationComponent from "react-reactstrap-pagination";
import Pagination from "react-responsive-pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import { CardFooter } from "reactstrap";
import TSSelect from "components/Forms/TSSelect";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import styles2 from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Button from "components/CustomButtons/Button.js";
import { Collapse, Modal, ModalBody } from "reactstrap";
import loading from "assets/img/loading-load.gif";
import axios from "utils/httpClient";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  cardCategory: {
    marginTop: "0",
    marginBottom: "3px",
    minHeight: "auto"
  },
  cardTitle: {
    marginTop: "0",
    marginBottom: "3px",
    minHeight: "auto"
  }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function TableList() {
  const classes = useStyles();
  const classes2 = useStyles2();
  // const [selectedPage, setSelectedPage] = useState(1);
  const [l1Option, setL1Option] = useState([]);
  const [l2Option, setL2Option] = useState([]);
  const [l3Option, setL3Option] = useState([]);
  const [l4Option, setL4Option] = useState([]);
  const [data, setData] = useState([]);
  const [dataInfo, setDataInfo] = useState([]);
  const [option1, setOption1] = useState("");
  const [option2, setOption2] = useState("");
  const [option3, setOption3] = useState("");
  const [option4, setOption4] = useState("");
  const [oldOption1, setOldOption1] = useState("");
  const [oldOption2, setOldOption2] = useState("");
  const [oldOption3, setOldOption3] = useState("");
  const [oldOption4, setOldOption4] = useState("");
  const [disable1, setDisable1] = useState(true);
  const [disable2, setDisable2] = useState(true);
  const [disable3, setDisable3] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const windowWidth = useWindowWidth();
  const [tableHead, setTableHead] = useState([]);
  const [year, setYear] = useState([]);
  const [value, setValue] = useState([]);
  const [isYear, setIsYear] = useState([]);
  const [selected, setSelected] = useState([]);
  const [select, setSelect] = useState([]);
  const [modal, setModal] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const initialSearchParam = new URLSearchParams(window.location.search).get("search") || "";
  const [searchTerm, setSearchTerm] = useState(initialSearchParam);
  const [activeSearch, setActiveSearch] = useState(initialSearchParam);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {

    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       setL1Option(result.data);
    //     },
    //     error => {
    //       console.log(error);
    //     }
    //   );

      axios("/api/v1/group1")
      .then(
        result => {
          var res = result.data;
          setL1Option(res.data);
        }, error => {console.log(error);}
      );  
  }, []);

  useEffect(() => {
    if (option1 !== "") {

      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setL2Option(result.data);
      //       setDisable1(false);
      //       setOldOption1(option1);
      //       // window.history.replaceState(
      //       //   null,
      //       //   "New Page Title",
      //       //   "/admin/table/" + option1
      //       // );
      //       if (option1 !== oldOption1) {
      //         setOption2("");
      //         setOption3("");
      //         setDisable2(true);
      //         setL3Option([]);
      //       }
      //     },
      //     error => {
      //       console.log(error);
      //     }
      //   );

      axios("/api/v1/group2/" + option1)
      .then(
        result => {
          var res = result.data;
          setL2Option(res.data);
          setDisable1(false);
          setOldOption1(option1);
          if (option1 !== oldOption1) {
            setOption2("");
            setOption3("");
            setDisable2(true);
            setL3Option([]);
          }
        }, 
        error => {
          console.log(error);
        }
      );  
    }
  }, [option1]);

  useEffect(() => {
    if (option1 === 1 || option1 === 4) {
      if (option2 !== "") {
        axios("/api/v1/subGroup3/" + option2)
          .then(response => response.data)
          .then(
            result => {
              setL3Option(result.data);
              setDisable2(false);
              setOldOption2(option2);
              // window.history.replaceState(
              //   null,
              //   "New Page Title",
              //   "/admin/table/" + option1 + "/" + option2
              // );
              if (option2 !== oldOption2) {
                setOption3("");
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    } else {
      // if (option1 !== "") {
      //   window.history.replaceState(
      //     null,
      //     "New Page Title",
      //     "/admin/table/" + option1 + "/" + option2
      //   );
      // }
      setOldOption2(option2);
    }
  }, [option2]);

  useEffect(() => {
    if (option1 === 4) {
      if (option3 !== "") {
        axios("/api/v1/subGroup4/" + option3)
          .then(response => response.data)
          .then(
            result => {
              setL4Option(result.data);
              setDisable3(false);
              setOldOption3(option3);
              if (option3 !== oldOption3) {
                setOption4("");
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    } else {
      setOldOption3(option3);
    }
  }, [option3]);

  useEffect(() => {
    setOldOption4(option4);
  }, [option4]);

  useEffect(() => {
    axios("/api/v1/year/")
      .then(response => response.data)
      .then(
        result => {
          tableHead.push(
            "",
            "",
            "ชื่อตัวชี้วัด",
            "ค่าเป้าหมาย",
            result[5].label,
            result[4].label,
            result[3].label,
            result[2].label,
            result[1].label,
            result[0].label
          );
          setYear(result);
        },
        error => {
          console.log(error);
        }
      );
  }, []);

  useEffect(() => {
    if (activeSearch !== "") return;
    if (option1 !== "" && (option2 === "" || option1 !== oldOption1)) {
      if (option1 !== oldOption1) {
        setCurrentPage(1);
      }
      setIsLoading(true);
      axios(
        "/api/v1/tableOption/" +
          option1 +
          "/pagination?PageNumber=1&PageSize=1000"
      )
        .then(response => response.data)
        .then(
          result => {
            bindTable(result);
            setIsLoading(false);
          },
          error => {
            console.log(error);
            setIsLoading(false);
          }
        );
    }
  }, [option1, activeSearch]);

  useEffect(() => {
    if (activeSearch !== "") return;
    if (option1 !== 1 && option1 !== 4) {
      if (option2 !== "") {
        if (option2 !== oldOption2) {
          setCurrentPage(1);
        }
        setIsLoading(true);
        axios(
          "/api/v1/table/" +
            option2 +
            "/pagination?PageNumber=1&PageSize=1000"
        )
          .then(response => response.data)
          .then(
            result => {
              //setData(result.data);
              bindTable(result);
              setIsLoading(false);
            },
            error => {
              console.log(error);
              setIsLoading(false);
            }
          );
      }
    } else if (option2 !== "" && (option3 === "" || option2 !== oldOption2)) {
      if (option2 !== oldOption2) {
        setCurrentPage(1);
      }
      setIsLoading(true);
      axios(
        "/api/v1/tableOption2/" +
          option2 +
          "/pagination?PageNumber=1&PageSize=1000"
      )
        .then(response => response.data)
        .then(
          result => {
            bindTable(result);
            setIsLoading(false);
          },
          error => {
            console.log(error);
            setIsLoading(false);
          }
        );
    }
  }, [option2, activeSearch]);

  useEffect(() => {
    if (activeSearch !== "") return;
    if (option1 === 1) {
      if (option3 !== "") {
        if (option3 !== oldOption3) {
          setCurrentPage(1);
        }
        setIsLoading(true);
        axios(
          "/api/v1/table2/" +
            option3 +
            "/pagination?PageNumber=1&PageSize=1000"
        )
          .then(response => response.data)
          .then(
            result => {
              //setData(result.data);
              bindTable(result);
              setIsLoading(false);
            },
            error => {
              console.log(error);
              setIsLoading(false);
            }
          );
      }
    }
    if (option3 !== "" && (option4 === "" || option3 !== oldOption3)) {
      if (option3 !== oldOption3) {
        setCurrentPage(1);
      }
      setIsLoading(true);
      axios(
        "/api/v1/tableOption3/" +
          option3 +
          "/pagination?PageNumber=1&PageSize=1000"
      )
        .then(response => response.data)
        .then(
          result => {
            bindTable(result);
            setIsLoading(false);
          },
          error => {
            console.log(error);
            setIsLoading(false);
          }
        );
    }
  }, [option3, activeSearch]);

  useEffect(() => {
    if (activeSearch !== "") return;
    if (option1 === 4) {
      if (option4 !== "") {
        if (option4 !== oldOption4) {
          setCurrentPage(1);
        }
        setIsLoading(true);
        axios(
          "/api/v1/table3/" +
            option4 +
            "/pagination?PageNumber=1&PageSize=1000"
        )
          .then(response => response.data)
          .then(
            result => {
              //setData(result.data);
              bindTable(result);
              setIsLoading(false);
            },
            error => {
              console.log(error);
              setIsLoading(false);
            }
          );
      }
    }
  }, [option4, activeSearch]);

  const isCheck = () => {
    if (option1 !== oldOption1) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck2 = () => {
    if (option2 !== oldOption2) {
      return [{ value: "", label: "" }];
    }
  };

  const isCheck3 = () => {
    if (option3 !== oldOption3) {
      return [{ value: "", label: "" }];
    }
  };

  function useWindowWidth() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth - 400);

    useEffect(() => {
      const resizeHandler = () => {
        setWindowWidth(window.innerWidth - 400);
      };

      window.addEventListener("resize", resizeHandler);
      return () => {
        window.removeEventListener("resize", resizeHandler);
      };
    }, []);

    return windowWidth;
  }

  const onSelected = e => {
    setSelected(e);
  };
  // function handleSelected(selectedPage) {
  //   setSelectedPage(selectedPage);
  // }

  // Search handlers
  const handleSearchChange = e => {
    const val = e.target.value;
    setSearchTerm(val);
    if (val === "" && activeSearch !== "") {
      setActiveSearch("");
      setCurrentPage(1);
    }
  };

  const handleSearchSubmit = e => {
    if (e) e.preventDefault();
    const trimmed = searchTerm.trim();
    if (trimmed === "") {
      setActiveSearch("");
      setCurrentPage(1);
    } else {
      setActiveSearch(trimmed);
      setCurrentPage(1);
    }
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setActiveSearch("");
    setCurrentPage(1);
  };

  const [sortDirection, setSortDirection] = useState("asc"); // "asc" | "desc"

  const handleToggleSort = () => {
    setSortDirection(prev => (prev === "asc" ? "desc" : "asc"));
  };

  const sortedData = useMemo(() => {
    if (!data || data.length === 0) return [];
    const list = [...data];
    list.sort((a, b) => {
      const nameA = (a[2] || "").toString().trim();
      const nameB = (b[2] || "").toString().trim();
      const cmp = nameA.localeCompare(nameB, "th", { numeric: true, sensitivity: "base" });
      return sortDirection === "asc" ? cmp : -cmp;
    });
    return list;
  }, [data, sortDirection]);

  const filteredData = useMemo(() => {
    if (!searchTerm || !searchTerm.trim()) return sortedData;
    const term = searchTerm.trim().toLowerCase();
    return sortedData.filter(item =>
      (item[2] || "")
        .toString()
        .toLowerCase()
        .includes(term)
    );
  }, [sortedData, searchTerm]);

  const totalPages = useMemo(() => {
    return Math.max(1, Math.ceil(filteredData.length / pageSize));
  }, [filteredData.length, pageSize]);

  const pagedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return filteredData.slice(startIndex, startIndex + pageSize);
  }, [filteredData, currentPage, pageSize]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, option1, option2, option3, option4]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(1);
    }
  }, [currentPage, totalPages]);

  useEffect(() => {
    if (activeSearch !== "") {
      setIsLoading(true);
      axios(
        "/api/v1/search/" +
          encodeURIComponent(activeSearch) +
          "/pagination?PageNumber=1&PageSize=1000"
      )
        .then(response => response.data)
        .then(
          result => {
            bindTable(result);
            setIsLoading(false);
          },
          error => {
            console.log(error);
            setIsLoading(false);
          }
        );
    }
  }, [activeSearch]);

  const bindTable = result => {
    var tableList = [];
    if (result && result.data && result.data.length > 0) {
      result.data.forEach(e => {
        const g1 = e.group1Id !== undefined && e.group1Id !== null ? e.group1Id : option1;
        const g2 = e.group2Id !== undefined && e.group2Id !== null ? e.group2Id : option2;
        const g3 = e.group3Id !== undefined && e.group3Id !== null ? e.group3Id : option3;
        const g4 = e.group4Id !== undefined && e.group4Id !== null ? e.group4Id : option4;

        if (e.listData && e.listData.length < 6) {
          var l1 = [];
          var name;
          var target;
          var tags;
          var flag;
          var flagTarget;
          var j = 0;
          for (var i = 0; i < 6; i++) {
            if (
              e.listData[j] !== undefined &&
              year[i] !== undefined &&
              e.listData[j].key.toString() === year[i].value
            ) {
              if (e.showId === 1) {
                l1 = l1.concat(
                  e.listData[j].value2 === null
                    ? 0
                    : e.listData[j].value2.toFixed(2)
                );
              } else if (e.showId === 2) {
                l1 = l1.concat(e.listData[j].value);
              }
              name = e.name;
              target = e.typeName + " " + Number(e.target).toLocaleString();
              tags = e.tags;
              flag = e.flag;
              flagTarget = e.flagTarget;
              j++;
            } else {
              l1 = l1.concat(0);
              name = e.name;
              target = e.typeName + " " + Number(e.target).toLocaleString();
              tags = e.tags;
              flag = e.flag;
              flagTarget = e.flagTarget;
            }
          }

          tableList.push([
            "Dashboard",
            "Edit",
            name,
            target,
            l1[5] !== undefined ? l1[5].toLocaleString() : 0,
            l1[4] !== undefined ? l1[4].toLocaleString() : 0,
            l1[3] !== undefined ? l1[3].toLocaleString() : 0,
            l1[2] !== undefined ? l1[2].toLocaleString() : 0,
            l1[1] !== undefined ? l1[1].toLocaleString() : 0,
            l1[0] !== undefined ? l1[0].toLocaleString() : 0,
            e.dataId,
            g1,
            g2,
            g3,
            g4,
            flag,
            flagTarget,
            tags
          ]);
        } else if (e.listData) {
          if (e.showId === 1 || e.showId === 3) {
            tableList.push([
              "Dashboard",
              "Edit",
              e.name,
              e.typeName + " " + Number(e.target).toLocaleString(),
              e.listData[5] === undefined
                ? 0
                : e.listData[5].value2.toFixed(2).toLocaleString(),
              e.listData[4] === undefined
                ? 0
                : e.listData[4].value2.toFixed(2).toLocaleString(),
              e.listData[3] === undefined
                ? 0
                : e.listData[3].value2.toFixed(2).toLocaleString(),
              e.listData[2] === undefined
                ? 0
                : e.listData[2].value2.toFixed(2).toLocaleString(),
              e.listData[1] === undefined
                ? 0
                : e.listData[1].value2.toFixed(2).toLocaleString(),
              e.listData[0] === undefined
                ? 0
                : e.listData[0].value2.toFixed(2).toLocaleString(),
              e.dataId,
              g1,
              g2,
              g3,
              g4,
              e.flag,
              e.flagTarget,
              e.tags
            ]);
          } else if (e.showId === 2 || e.showId === 4) {
            tableList.push([
              "Dashboard",
              "Edit",
              e.name,
              e.typeName + " " + Number(e.target).toLocaleString(),
              e.listData[5] === undefined
                ? 0
                : e.listData[5].value.toLocaleString(),
              e.listData[4] === undefined
                ? 0
                : e.listData[4].value.toLocaleString(),
              e.listData[3] === undefined
                ? 0
                : e.listData[3].value.toLocaleString(),
              e.listData[2] === undefined
                ? 0
                : e.listData[2].value.toLocaleString(),
              e.listData[1] === undefined
                ? 0
                : e.listData[1].value.toLocaleString(),
              e.listData[0] === undefined
                ? 0
                : e.listData[0].value.toLocaleString(),
              e.dataId,
              g1,
              g2,
              g3,
              g4,
              e.flag,
              e.flagTarget,
              e.tags
            ]);
          }
        }
      });
    }

    // Sort alphabetically by indicator name (ก-ฮ) using Thai collation with natural numeric sort
    tableList.sort((a, b) => (a[2] || "").localeCompare(b[2] || "", "th", { numeric: true, sensitivity: "base" }));

    setData(tableList);
    const totalCountVal = result && result.total ? result.total : tableList.length;
    setTotalCount(totalCountVal);
  };

  //   const handleConfirm = evt => {
  //     evt.preventDefault();
  //     setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

  //     const requestOptions = {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json-patch+json"
  //       },
  //       body: JSON.stringify({
  //         selected: selected,
  //         option1Save: option1 === "" ? null : option1,
  //         option2Save: option2 === "" ? null : option2,
  //         option3Save: option3 === "" ? null : option3,
  //         option4Save: option4 === "" ? null : option4,

  //       })
  //     };


  //     .then(response => response.json())
  //     .then(
  //       result => {
  //         setModal(false);
  //         setIcon("far fa-question-circle");
  //       },
  //       error => {
  //         alert(error);
  //       }
  //     );
  // };

  // const handleSubmit = evt => {
  //   evt.preventDefault();
  //   var cntErr = 0;

  //   var errMsg = [];

  //   if (cntErr > 0) {
  //     setErrMsg(errMsg);
  //     setModalError(true);
  //   } else {
  //     setModal(true);
  //   }
  // };
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Icon>
                  <AssignmentInd />
                </Icon>
              </CardIcon>
              {/* <p className={classes2.cardCategory}>Welcome to</p> */}
              <p className={classes2.cardCategory}>กรุณาเลือก</p>
              <h3 className={classes2.cardTitle}>
                หน่วยงาน <small></small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={999}
                    options={l1Option}
                    onChange={e => {
                      setSearchTerm("");
                      setActiveSearch("");
                      setOption1(e);
                    }}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={998}
                    options={l2Option}
                    onChange={e => {
                      setSearchTerm("");
                      setActiveSearch("");
                      setOption2(e);
                    }}
                    disabled={disable1}
                    defaulfAdd={isCheck()}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
              {(option1 === 1 || option1 === 4) && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      zIndex={997}
                      options={l3Option}
                      onChange={e => {
                        setSearchTerm("");
                        setActiveSearch("");
                        setOption3(e);
                      }}
                      disabled={disable2}
                      defaulfAdd={isCheck2()}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <div style={{ paddingTop: "10px" }}></div>
              {option1 === 4 && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <TSSelect
                      zIndex={996}
                      options={l4Option}
                      onChange={e => {
                        setSearchTerm("");
                        setActiveSearch("");
                        setOption4(e);
                      }}
                      disabled={disable3}
                      defaulfAdd={isCheck3()}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <div style={{ paddingTop: "10px" }}></div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}></GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="info">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px"
                }}
              >
                <div>
                  <h4 className={classes.cardTitleWhite}>รายการตัวชี้วัด</h4>
                  <p className={classes.cardCategoryWhite}>
                    {/* Here is a subtitle  */}
                    <tr>
                      <td style={{ paddingRight: "10px", border: "0px solid" }}>
                        ตัวชี้วัดที่ปีงบประมาณล่าสุดเป็นสี
                      </td>
                      <td
                        style={{
                          backgroundColor: "orange",
                          color: "orange",
                          border: "0px solid"
                        }}
                      >
                        tttt
                      </td>
                      <td style={{ paddingLeft: "10px", border: "0px solid" }}>
                        คือตัวชี้วัดที่ยังไม่ได้อนุมัติ
                      </td>
                    </tr>
                    {/* for this table */}
                  </p>
                </div>

                {/* ช่องค้นหาตัวชี้วัดขนาดเล็กใน Header แสดงเมื่อเลือกหน่วยงานแล้ว หรือมี data ใน table */}
                {(option1 !== "" || (data && data.length > 0)) && (
                  <div
                    style={{
                      position: "relative",
                      width: "250px",
                      maxWidth: "100%"
                    }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      placeholder="ค้นหาชื่อตัวชี้วัด..."
                      value={searchTerm}
                      onChange={e => setSearchTerm(e.target.value)}
                      onKeyDown={e => {
                        if (e.key === "Enter") e.preventDefault();
                      }}
                      style={{
                        fontFamily: '"Sarabun", sans-serif',
                        fontSize: "13px",
                        height: "34px",
                        paddingLeft: "32px",
                        paddingRight: searchTerm ? "28px" : "10px",
                        borderRadius: "17px",
                        border: "1px solid rgba(255,255,255,0.7)",
                        backgroundColor: "#ffffff",
                        color: "#333",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.15)"
                      }}
                    />
                    <span
                      style={{
                        position: "absolute",
                        left: "11px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#00acc1",
                        pointerEvents: "none",
                        fontSize: "13px"
                      }}
                    >
                      <i className="fa fa-search"></i>
                    </span>
                    {searchTerm && (
                      <button
                        type="button"
                        onClick={() => setSearchTerm("")}
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          background: "none",
                          border: "none",
                          color: "#888",
                          cursor: "pointer",
                          fontSize: "14px",
                          padding: "0"
                        }}
                        title="ล้างคำค้นหา"
                      >
                        <i className="fa fa-times-circle"></i>
                      </button>
                    )}
                  </div>
                )}
              </div>
            </CardHeader>
            <CardBody>
              {!isLoading && (
                <Table
                  tableHeaderColor="info"
                  tableHead={tableHead}
                  tableData={pagedData}
                  select={onSelected}
                  tableSelect={select}
                  sortDirection={sortDirection}
                  onToggleSort={handleToggleSort}
                />
              )}
              {isLoading && (
                <div style={{ textAlign: "center" }}>
                  <img style={{ width: "20%" }} src={loading} alt="..." />
                </div>
              )}
            </CardBody>
            <CardFooter style={{ textAlign: "center" }}>
              {/* <PaginationComponent
              totalItems={50}
              pageSize={10}
              onSelect={handleSelected}
            /> */}
              <Pagination
                current={currentPage}
                total={totalPages}
                onPageChange={setCurrentPage}
                maxWidth={windowWidth}
              />

              {/* <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Button color="primary" onClick={handleSubmit}>
                <h4>Approve</h4>
              </Button>
              </GridItem>
          </GridContainer> */}
            </CardFooter>
          </Card>
        </GridItem>
        {/* <GridItem xs={12} sm={12} md={12}>
        <Card plain>
          <CardHeader plain color="primary">
            <h4 className={classes.cardTitleWhite}>
              Table on Plain Background
            </h4>
            <p className={classes.cardCategoryWhite}>
              Here is a subtitle for this table
            </p>
          </CardHeader>
          <CardBody>
            <Table
              tableHeaderColor="primary"
              tableHead={["ID", "Name", "Country", "City", "Salary"]}
              tableData={[
                ["1", "Dakota Rice", "$36,738", "Niger", "Oud-Turnhout"],
                ["2", "Minerva Hooper", "$23,789", "Curaçao", "Sinaai-Waas"],
                ["3", "Sage Rodriguez", "$56,142", "Netherlands", "Baileux"],
                [
                  "4",
                  "Philip Chaney",
                  "$38,735",
                  "Korea, South",
                  "Overland Park"
                ],
                [
                  "5",
                  "Doris Greene",
                  "$63,542",
                  "Malawi",
                  "Feldkirchen in Kärnten"
                ],
                ["6", "Mason Porter", "$78,615", "Chile", "Gloucester"]
              ]}
            />
            <div className="container-fluid">
              <h3>Reacstrap Pagination Component</h3>
              <hr />
              <h5>Selected page: {selectedPage}</h5>
              <hr />
              <h5>Default maxPaginationNumbers (5)</h5>
              <PaginationComponent
                totalItems={50}
                pageSize={10}
                onSelect={handleSelected}
              />
            </div>
          </CardBody>
        </Card>
      </GridItem> */}
      </GridContainer>
      {/* <GridContainer>
        <Modal toggle={() => setModal(false)} isOpen={modal}>
          <div className="modal-header justify-content-center">
            <div>
              <i
                className={icon}
                style={{ color: "blue", fontSize: "2em" }}
              ></i>
            </div>
           </div>
           <ModalBody>
                  <p
                    style={{
                      textAlign: "center"
                    }}
                  >
                    {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                      ? "ยืนยันการบันทึกข้อมูล"
                      : "กำลังตรวจสอบข้อมูล"}
                  </p>
                  <p> </p>
                </ModalBody>
                <div className="modal-footer">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => setModal(false)}
                  >
                    <h4>ยกเลิก</h4>
                  </Button>

                  <Button
                    color="primary"
                    type="button"
                    onClick={handleConfirm}
                    disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                  >
                    <h4>ยืนยัน</h4>
                  </Button>
                </div>
              </Modal>
            </GridContainer> */}
    </div>
  );
}
